import useReveal from '@/hooks/useReveal';

export default function DescriptionSection() {
  const { ref, visible } = useReveal();

  return (
    <section className="relative w-full bg-background-100">
      <div
        ref={ref}
        className={`reveal ${visible ? 'visible' : ''} w-full max-w-[1280px] mx-auto flex flex-col lg:flex-row py-28 md:py-32 lg:py-[140px] px-6 md:px-10 lg:px-20`}
      >
        <div className="w-full lg:w-[55%] flex flex-col gap-6 md:gap-7">
          <p className="text-lg sm:text-[19px] md:text-[20px] font-body font-normal leading-[1.7] text-foreground-900 max-w-[64ch]">
            The company is a professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies.
          </p>
          <p className="text-lg sm:text-[19px] md:text-[20px] font-body font-normal leading-[1.7] text-foreground-900 max-w-[64ch]">
            It builds scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality. The team follows modern software engineering practices, including clean architecture, performance optimization, and user-centered design.
          </p>
          <p className="text-lg sm:text-[19px] md:text-[20px] font-body font-normal leading-[1.7] text-foreground-900 max-w-[64ch]">
            The company emphasizes continuous innovation, improvement of development workflows, and adoption of up-to-date engineering standards to deliver reliable and future-ready IT solutions. It actively explores new technologies and evolves its internal processes to maintain high technical excellence.
          </p>
        </div>
        <div className="hidden lg:flex lg:w-[45%] justify-start pl-16">
          <div className="w-px h-[240px] bg-background-300/70 self-start" />
        </div>
      </div>
    </section>
  );
}